<div class="tw-relative tw-w-full">
  <div
    #measureRow
    class="tw-fixed tw-left-[-9999px] tw-top-0 tw-flex tw-gap-2 tw-pointer-events-none"
    aria-hidden="true"
  >
    @for (persona of personas(); track persona.id) {
      <span
        data-measure-tab
        class="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-px-[14px] tw-py-2.5 tw-border-0 tw-rounded-md tw-font-inter tw-text-sm tw-font-medium tw-leading-normal tw-uppercase tw-whitespace-nowrap"
      >
        {{ persona.name }}
      </span>
    }
    <span
      data-measure-more
      class="tw-inline-flex tw-items-center tw-gap-2 tw-shrink-0 tw-px-[14px] tw-py-2.5 tw-border-[3px] tw-border-solid tw-border-transparent tw-font-inter tw-text-sm tw-font-medium tw-leading-normal tw-whitespace-nowrap"
    >
      <span>More</span>
      <span class="tw-size-3.5 tw-shrink-0"></span>
    </span>
  </div>

  <ng-template #personaTab let-persona="persona">
    <button
      type="button"
      role="tab"
      class="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-px-[14px] tw-py-2 lg:tw-py-2.5 tw-border-0 tw-rounded-md tw-cursor-pointer tw-font-inter tw-text-sm tw-font-medium tw-leading-normal tw-uppercase tw-whitespace-nowrap"
      [ngClass]="
        selectedPersonaId() === persona.id
          ? 'tw-bg-blue-600 tw-text-white'
          : 'tw-bg-transparent tw-text-gray-500 hover:tw-text-gray-600'
      "
      [attr.aria-selected]="selectedPersonaId() === persona.id"
      (click)="onPersonaClick(persona.id)"
    >
      {{ persona.name }}
    </button>
  </ng-template>

  <div
    class="tw-flex tw-items-center tw-gap-2 tw-w-full tw-overflow-x-auto tw-overflow-y-hidden lg:tw-hidden [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:tw-hidden tw-bg-gray-100 tw-py-4"
    role="tablist"
    aria-label="Persona tabs"
  >
    @for (persona of personas(); track persona.id) {
      <ng-container [ngTemplateOutlet]="personaTab" [ngTemplateOutletContext]="{ persona }" />
    }
  </div>

  <div
    #tabsContainer
    class="tw-hidden lg:tw-flex tw-items-center tw-gap-2 tw-w-full"
    role="tablist"
    aria-label="Persona tabs"
  >
    @for (persona of visiblePersonas(); track persona.id) {
      <ng-container [ngTemplateOutlet]="personaTab" [ngTemplateOutletContext]="{ persona }" />
    }

    @if (overflowPersonas().length > 0) {
        <app-dropdown
          class="tw-shrink-0 tw-w-auto [&_section]:!tw-w-auto"
          [dropdownOptions]="overflowDropdownOptions()"
          [widthInPX]="'148px'"
          [heightInPX]="moreDropdownHeight()"
          [dropdownListXPosition]="'right'"
          [dropdownListYPosition]="'bottom'"
          (optionClicked)="onOverflowOptionClicked($event)"
          (dropdownOpened)="onMoreDropdownOpened()"
          (dropdownClosed)="onMoreDropdownClosed()"
        >
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-gap-2 tw-px-[14px] tw-py-2.5 tw-border-[3px] tw-rounded-md tw-cursor-pointer tw-font-inter tw-text-sm tw-font-medium tw-leading-normal tw-whitespace-nowrap"
            [ngClass]="
              isMoreOpen()
                ? 'tw-border-blue-200 tw-bg-blue-800 tw-text-white hover:tw-text-white'
                : 'tw-border-transparent tw-bg-transparent tw-text-gray-500 hover:tw-text-gray-600'
            "
            aria-haspopup="listbox"
            [attr.aria-expanded]="isMoreOpen()"
          >
            <span>More</span>
            <svg
              class="tw-size-3.5 tw-shrink-0"
              [ngClass]="isMoreOpen() ? 'tw-text-white' : 'tw-text-gray-500'"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.5 5.25L7 8.75L10.5 5.25"
                [attr.stroke]="isMoreOpen() ? '#ffffff' : 'currentColor'"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </app-dropdown>
      }
  </div>
</div>
